import React from "react";
import ResultTitle from "./components/resulttitle";
import PartyResult from "./components/partyresult";
import PartyHeaders from "./components/partyheaders";
import ElectionAction from "../../Actions/ElectionAction"

export default class StateResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.fetchStatedata = this.fetchStatedata.bind(this);
  }
  componentDidMount() {

    this.fetchStatedata();


  }
  fetchStatedata() {
    let jsondata = {};
    let queryparams = this.props.queryparams;
    let data = {};
    let time = 30000;
    try {
      data['islive'] = queryparams['islive'];
    } catch (e) {

    }
    let response = ElectionAction.statewise(data);
    if (typeof response == "object") {
      response.then((result) => {
        jsondata = result['data'];
        try {
          jsondata = jsondata['data']['data'];
          if (Object.keys(jsondata).length > 0) {

            this.setState({ ...jsondata }, () => {
              // console.log("realtimedata")
              setTimeout(() => {
                this.fetchStatedata();
              }, time);

            });
          } else {
            console.log("storagedata cond1", 'error');
            setTimeout(() => {
              this.fetchStatedata();
            }, time);



          }
        } catch (e) {
          console.log("storagedata cond2", 'error');
          setTimeout(() => {
            this.fetchStatedata();
          }, time);
          // try {
          //   let lo_data = localStorage.getItem("_statewise");
          //   lo_data = JSON.parse(lo_data);
          //   if (Object.keys(lo_data).length > 0) {
          //     console.log("storagedata ", e.message);
          //     this.setState({ ...lo_data }, () => {
          //       setTimeout(() => {
          //         this.fetchStatedata();
          //       }, time);
          //     })
          //   }
          // } catch (e) {

          // }

        }


      }).catch((error) => {
        console.log("storagedata cond3", 'error', error.message);
        setTimeout(() => {
          this.fetchStatedata();
        }, time);
        // try {
        //   let lo_data = localStorage.getItem("_statewise");
        //   lo_data = JSON.parse(lo_data);
        //   if (Object.keys(lo_data).length > 0) {
        //     console.log("storagedata", error.message);
        //     this.setState({ ...lo_data }, () => {
        //       setTimeout(() => {
        //         this.fetchStatedata();
        //       }, time);
        //     })
        //   }
        // } catch (e) {

        // }
      });
    } else {
      console.log("storagedata cond4", 'error');
      setTimeout(() => {
        this.fetchStatedata();
      }, time);
      // try {
      //   let lo_data = localStorage.getItem("_statewise");
      //   lo_data = JSON.parse(lo_data);
      //   if (Object.keys(lo_data).length > 0) {
      //     console.log("storagedata", 'error');
      //     this.setState({ ...lo_data }, () => {
      //       setTimeout(() => {
      //         this.fetchStatedata();
      //       }, time);
      //     })
      //   }
      // } catch (e) {

      // }
    }



  }

  render() {
    let stateRes = this.state;
    return (
      <div>
        {
          stateRes && Object.keys(stateRes).length > 0 ? Object.keys(stateRes).map((items, index) => {
            let alliances = stateRes[items]['alliances'];
            let totalSeats = 0;
            try {
              if (alliances && Object.keys(alliances).length > 0) {

                Object.keys(alliances).map((a_key) => {

                  if (alliances && alliances[a_key] && alliances[a_key]['totalSeats']) {
                    totalSeats = totalSeats + parseInt(alliances[a_key]['totalSeats']);
                  }

                })
              }
            } catch (error) {

            }


            return (<section className="election_section" key={Math.random()}>
              <ResultTitle data={stateRes[items]} countedSeats={totalSeats} />
              <table className="election_result_main ">
                <PartyHeaders data={alliances} />
                <PartyResult data={alliances} isremove={1} />
              </table>
            </section>)
          })
            : ""
        }
      </div>
    );
  }
}
